// extracted by mini-css-extract-plugin
export default {"media-container":"rWP3Gv","mediaContainer":"rWP3Gv"};